import React from "react";
import ReactDOM from "react-dom";
import VRController from "../VRComponent/components/VRController";
import { VRWrapper, notifyStileOnSafari } from "../VRComponent/SafariResizeFix";
import "../../../scss/reset.scss";

window.onload = () => {
    notifyStileOnSafari();

    ReactDOM.render(
        <VRWrapper>
            <VRController
                imgSrc={require("./assets/lab-safety.jpg")}
                title={"Lab safety"}
            />
        </VRWrapper>,
        document.querySelector("#react-components"),
    );
};
